/// <reference types="vite/client" />
// Fetch the OpenRouter model catalog via our Function proxy. Uses a simple
// in-module memoize so repeat callers in the same page session share one
// network call; the Function itself caches for 24h.

import { useEffect, useState } from 'react'

const FUNCTION_URL =
  import.meta.env.VITE_OPENROUTER_MODELS_URL ?? 'https://openroutermodels-efll3x5snq-uc.a.run.app'

/** @type {Promise<any[]> | null} */
let cachedPromise = null

async function loadOnce() {
  if (cachedPromise) return cachedPromise
  cachedPromise = (async () => {
    const res = await fetch(FUNCTION_URL)
    if (!res.ok) throw new Error(`openRouterModels ${res.status}`)
    const { models } = await res.json()
    return Array.isArray(models) ? models : []
  })()
  try {
    return await cachedPromise
  } catch (err) {
    cachedPromise = null
    throw err
  }
}

/**
 * React hook wrapping the model catalog fetch.
 *
 * @returns {{ data: any[], loading: boolean, error: Error | null }}
 */
export function useOpenRouterModels() {
  const [state, setState] = useState(
    /** @type {{ data: any[], loading: boolean, error: Error | null }} */ ({
      data: [],
      loading: true,
      error: null,
    }),
  )
  useEffect(() => {
    let cancelled = false
    loadOnce()
      .then((models) => {
        if (!cancelled) setState({ data: models, loading: false, error: null })
      })
      .catch((err) => {
        if (!cancelled) setState({ data: [], loading: false, error: err })
      })
    return () => {
      cancelled = true
    }
  }, [])
  return state
}

export function _resetCacheForTests() {
  cachedPromise = null
}
